<template>
  <PageSection>
    <PageSectionHeading>
      Property Details
    </PageSectionHeading>
    <div class="md:hidden mb-6">
      <vue-collapsible-panel-group
        accordion
        style="--bg-color-header: #fafafa;"
      >
        <vue-collapsible-panel
          v-for="(section,i) in detailSections"
          :key="section.key"
          :expanded="i === 0"
        >
          <template #title>
            <span class="uppercase">
              {{ section.title }}
            </span>
          </template>
          <template #content>
            <DetailTable
              class="mb-6 text-sm uppercase"
              :details="section.content"
              :property="property"
            />
          </template>
        </vue-collapsible-panel>
      </vue-collapsible-panel-group>
    </div>
    <tabs
      class="hidden md:block"
      :class="{branded}"
      :options="{ useUrlFragment: false }"
    >
      <tab
        v-for="section in detailSections"
        :key="section.key"
        :name="section.title"
      >
        <DetailTable
          class="mb-6 text-sm uppercase"
          :details="section.content"
          :property="property"
        />
      </tab>
    </tabs>
    <VirtualTourBtn
      v-if="shouldShowVirtualTourButton"
      :property="property"
    />
  </PageSection>
</template>
<script>
import { Tabs, Tab } from 'vue3-tabs-component';

import {
  VueCollapsiblePanelGroup,
  VueCollapsiblePanel,
} from '@swoga/vue-collapsible-panel';
import '@swoga/vue-collapsible-panel/dist/vue-collapsible-panel.css';

import PageSection from '../components/PageSection.vue';
import PageSectionHeading from '../components/PageSectionHeading.vue';
import DetailTable from '../components/DetailTable.vue';
import details from '../../../data/details';
import VirtualTourBtn from '../components/VirtualTourBtn.vue';

export default {
  components: {
    VirtualTourBtn,
    DetailTable,
    PageSectionHeading,
    PageSection,
    Tabs,
    Tab,
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
  },
  props: {
    property: {
      type: Object,
      required: true,
    },
    branded: {
      type: Boolean,
      required: true,
    },
    shouldShowVirtualTourButton: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    detailSections() {
      return details;
    },
  },
};
</script>

<style lang="scss">
.tabs-component-tabs {
  @apply flex justify-between mb-3;

  .tabs-component-tab {

    @apply border-b-2;
    @apply text-center uppercase text-sm;
    @apply font-bold;
    @apply py-1;

    &.is-active {

      @apply border-black;
      @at-root .branded & {
        @apply text-secondary;
        @apply border-secondary;
      }
    }

    a {
      display: block;
    }
  }
}

</style>
